define('SageDotCom/Components/SolutionListing',[
    'jquery',
    'underscore',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Util/trackingHelper',
    'SageDotCom/DataLayer/Events/searchSelection',
    'SageDotCom/DataLayer/Events/searchRefinement',
    'text!SageDotCom/Components/Templates/SolutionListing.html',
    'eventManager',
    'SageDotCom/Components/SlickSliderSettings',
    "SageDotCom/Utility/sageMatchHeight"
], function ($, _, tealium, trackingHelper, searchSelection, searchRefinement, solutionListingTemplate, eventManager, SlickSliderSettings, SageMatchHeight) {

    function SolutionListing(scope, allLabelText, solution, slidesToShow, slidesToScroll, responsiveDisplay) {
        solution = JSON.parse(solution);
        var FacetArray = [];
        var SolutionListingArray = [];

        var SolutionStringValue = "[" + solution["m_StringValue"].replace(/}{/g, '},{') + "]";
        var SolutionArray = $.parseJSON(SolutionStringValue);

        for (var i = 0; i < SolutionArray.length; i++) {
            var allObject = {
                "AllLabelText": allLabelText
            };
            $.extend(SolutionArray[i], allObject);
            SolutionListingArray.push(SolutionArray[i]);
        }

        $.each(SolutionArray, function (objectkey, objectvalue) {
            $.each(objectvalue,
                function (facetkey, facetValue) {
                    if (facetkey === "TileCategory") {
                        $.each(facetValue,
                            function (key, value) {
                                FacetArray.push(value);
                            });
                    }
                });
        });

        var $solutions = $(".score-slick-slider", scope);
        addFacetLi(SolutionListingArray, unique(FacetArray).sort(), allLabelText, $solutions, solutionListingTemplate);


        scope.addEventListener('lazy-load-evt',
            setSlider(SolutionListingArray,
                $solutions,
                solutionListingTemplate,
                responsiveDisplay,
                allLabelText,
                slidesToShow,
                slidesToScroll));

        var timeoutSS;
        var saveWidthSS = $(window).width();
        $(window).resize(function () {
            if (saveWidthSS != $(window).width()) {
                saveWidthSS = $(window).width();
                clearTimeout(timeoutSS);
                timeoutSS = setTimeout(function () {
                    setSlider(SolutionListingArray,
                        $solutions,
                        solutionListingTemplate,
                        responsiveDisplay, allLabelText, slidesToShow, slidesToScroll);
                }, 500);
            }
        });

        $('.score-facet-button').on('click', function (e) {
            e.preventDefault();
            $(this).addClass("active").siblings().removeClass('active');
            var facetValue = $(this).attr("data-category");
            var facetCount = $(this).children(".score-facet-count").text();
            if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-value").text(facetValue.replace("-", " "));
            if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-count").text(facetCount);

            setSlider(SolutionListingArray,
                $solutions,
                solutionListingTemplate,
                responsiveDisplay, facetValue, slidesToShow, slidesToScroll);

            var eventObj = searchSelection.GenerateEventMetadata(event.currentTarget, null, facetValue);
            tealium.event(eventObj);
        });

        trackingHelper.registerTracking(scope, searchSelection.getName());
        trackingHelper.registerTracking(scope, searchRefinement.getName());
    }

    function setSlider(solutionListingArray,
        $solutions,
        solutionListingTemplate,
        responsiveDisplay,
        facetValue,
        slidesToShow,
        slidesToScroll) {

        var facetValue = $('.score-facet-button.active').attr("data-category");
        var facetCount = $('.score-facet-button.active').children(".score-facet-count").text();
        if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-value").text(facetValue.replace("-", " "));
        if ($("#dropdownMenu1")) $("#dropdownMenu1 .score-facet-count").text(facetCount);

        if ($solutions.hasClass('slick-initialized')) {
            $($solutions).slick('unslick');
            $($solutions).empty();
        }

        getListingResults($solutions, solutionListingArray, solutionListingTemplate);

        //uses same method as resourceListing as it has the exact same settings
        var slickSettings = SlickSliderSettings.getSlickSliderResourceListingSettings(slidesToShow); 

        new Promise(function (resolve, reject) {
            $($solutions).slick(slickSettings);
            $solutions.slick('slickUnfilter');
            $solutions.slick('slickFilter', $('.' + facetValue.replace(/\s+/g, '-')).parent().parent());
            SageMatchHeight.prototype.applyBinding($(".sage-solution-card-header"), true);
            SageMatchHeight.prototype.applyBinding($(".sage-solution-card-content"), true);

            eventManager.trigger("lazy-animate-element", $solutions.parent());
            resolve();
        });
    }

    function unique(array) {
        return $.grep(array, function (el, index) {
            return index === $.inArray(el, array);
        });
    }

    function addFacetLi(solutionListingArray, facetArray, allLabelText) {
        var liToAppend = "<li class='score-facet-button js-category active' data-category='" + allLabelText.replace(/\s+/g, '-') + "'>" +
            "<span class='score-facet-value'><a href='#'>" +
            allLabelText +
            "</a></span>" +
            "<span class='score-facet-count'>" +
            solutionListingArray.length +
            "</span>" +
            "</li>";

        $(".solution-facets-container .dropdown-menu").append(liToAppend);
        $.each(facetArray,
            function (key, value) {
                $(".solution-facets-container .dropdown-menu").append("<li class='score-facet-button js-category' data-category='" + value.replace(/\s+/g, '-') + "'>" +
                    "<span class='score-facet-value'><a href='#'>" + value + "</a></span>" +
                    "<span class='score-facet-count'>" + getFacetCount(solutionListingArray, value) + "</span>" +
                    "</li>");
            });

    }

    function getFacetCount(solutionListingArray, currentfacetValue) {
        var i = 0;
        $.each(solutionListingArray, function (objectkey, objectvalue) {
            $.each(objectvalue,
                function (facetkey, facetValue) {
                    if (facetkey === "TileCategory" && facetValue.indexOf(currentfacetValue) > -1) {
                        i++;
                    }
                });
        });

        return i;
    }

    function getListingResults(solutions, solutionListingArray, solutionListingTemplate) {
        for (var i = 0; i < solutionListingArray.length; i++) {
            var _resultTemplate = _.template(solutionListingTemplate);
            var resultsTemplate = _resultTemplate(solutionListingArray[i]);

            $(solutions).append(resultsTemplate);
        }
    }

    return function initSolutionListing(args) {
        return args.IsExperienceEditorEditing === false
            ? new SolutionListing(args.scope, args.AllLabelText, args.Solution, args.SlidesToShow, args.SlidesToScroll, args.ResponsiveDisplay)
            : null;
    }
});
